import React from 'react';
import SimpleConfirmationDialog from "../SimpleConfirmationDialog";
import { deleteInventoryActivity } from "../../requests/inventory-requests";
import { withSnackbar } from "../hocs/withSnackbar";
import Busy from "../Busy";
import { getErrorMessageForStandardResponse } from "../../util/NetworkErrorUtil";


const DeleteInterchangeConfirmationDialog = ({
  inventoryActivity = {},
  onClose = () => { },
  onSuccess = () => { },
  open = false,
  snackbarShowMessage = () => { }
}) => {

  const onConfirm = () => {
    Busy.set(true);
    deleteInventoryActivity(inventoryActivity.locationInventoryActivityGetVO.id).then(() => {
      snackbarShowMessage(`Successfully deleted interchange activity with booking ID ${inventoryActivity.orderNumber}`, 'success', 8000);
      onSuccess();
    }).catch((err) => {
      snackbarShowMessage(getErrorMessageForStandardResponse(err), 'error', 8000);
    }).finally(() => {
      Busy.set(false);
    });
  };

  return (
    <SimpleConfirmationDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={"Delete Interchange"}
      body={"Are you sure you want to delete this interchange?"}
    />
  );
};

export default withSnackbar(DeleteInterchangeConfirmationDialog);
